import React, {useState} from 'react';
import {Market} from 'types';
import {MarketNamingTemplateDescriptions} from './MarketNamingTemplateDescriptions';
import {useMarketNamingTemplateValidation} from './hooks';
import {Separator, Toggle} from '@fluentui/react';
import {useBoolean} from '@fluentui/react-hooks';

type MarketProps = keyof Market;

export type MarketNamingTemplateKeys = Extract<
	MarketProps,
	'regulationNamingTemplates' | 'regulatoryDocumentNamingTemplates'
>;

export type InputMarketProps = Pick<
	Market,
	| 'id'
	| 'name'
	| 'regulationNamingTemplates'
	| 'regulatoryDocumentNamingTemplates'
>;

type MarketNamingTemplateFieldChildProps = {
	validateFieldValue: (value: string) => boolean | string;
	isMarketSelected: boolean;
	placeholder: string;
};

type MarketNamingTemplateFieldProps = {
	markets: InputMarketProps[];
	namingHint: string;
	templatesToUse: MarketNamingTemplateKeys;
	label: string;
	children: (props: MarketNamingTemplateFieldChildProps) => React.ReactNode;
};

export const MarketNamingTemplateField: React.FC<
	MarketNamingTemplateFieldProps
> = ({markets, namingHint, templatesToUse, label, children}) => {
	const [freeText, setFreeText] = useState<boolean>(false);

	const {validateFieldValue, isMarketSelected, placeholder} =
		useMarketNamingTemplateValidation(markets, namingHint, templatesToUse);

	const handleChange = () => {
		setFreeText(!freeText);
	};

	const validateFieldValueFinal = (value: string) =>
		freeText || validateFieldValue(value);

	return (
		<React.Fragment>
			{children({
				validateFieldValue: validateFieldValueFinal,
				isMarketSelected,
				placeholder,
			})}
			<MarketNamingTemplateDescriptions
				markets={markets}
				templatesToUse={templatesToUse}
			/>
			{markets.length > 0 && (
				<>
					<Toggle label={label} checked={freeText} onChange={handleChange} />
					<Separator />
				</>
			)}
		</React.Fragment>
	);
};
